// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-center[data-v-40405ae8] {\n  text-align: center;\n}\n.divider-color[data-v-40405ae8] {\n  border-color: #2196f3;\n}\n.col-1[data-v-40405ae8] {\n  width: 1%;\n}\n.col-5[data-v-40405ae8] {\n  width: 5%;\n}\n.col-8[data-v-40405ae8] {\n  width: 8%;\n}\n.col-10[data-v-40405ae8] {\n  width: 10%;\n}\n.release-notes-content[data-v-40405ae8] {\n  max-height: 10em;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
